import React from "react";
import FormFieldEditor from "./FormFieldEditor";
import FormSectionEditor from "./FormSectionEditor";

// Right-hand panel of the drag-and-drop builder (Part B, item 4). Shows the
// selected field's full property set (label, validation, scoring, options,
// conditional logic — via FormFieldEditor) when a field is selected on the
// canvas; otherwise falls back to the selected section's own metadata (via
// FormSectionEditor) so the panel is never empty while a section exists.
export default function FormFieldPropertiesPanel({ section, field, allFieldKeys, allFields, onChangeSection, onChangeField, readOnly, fieldErrors, sectionsWeightageTotal }) {
  if (field) {
    return (
      <div className={`form-properties-panel${readOnly ? " is-readonly" : ""}`}>
        {readOnly && <div className="form-properties-readonly-notice">Create a new version to edit field properties.</div>}
        <FormFieldEditor
          field={field}
          otherFieldKeys={allFieldKeys.filter((k) => k !== field.field_key)}
          allFields={allFields}
          onChange={onChangeField}
          readOnly={readOnly}
          errors={fieldErrors}
        />
      </div>
    );
  }

  if (section) {
    return (
      <div className={`form-properties-panel${readOnly ? " is-readonly" : ""}`}>
        {readOnly && <div className="form-properties-readonly-notice">Create a new version to edit section properties.</div>}
        <FormSectionEditor section={section} onChangeSection={onChangeSection} readOnly={readOnly} sectionsWeightageTotal={sectionsWeightageTotal} />
      </div>
    );
  }

  return (
    <div className="form-properties-panel">
      <div className="text-muted small p-3">Select a field or a section to edit its properties.</div>
    </div>
  );
}
